module.exports = __webpack_public_path__ + "media/img/illustrations/S2U-People-f075c224c6d39731ad053ac22cecc527.svg";